import Navigation from './home/components/Navigation';
import Footer from './home/components/Footer';
import Seo from '../components/Seo';
import EsnafCard from './esnaf/EsnafCard';
import EsnafJoin from './esnaf/EsnafJoin';
import { groupByIlce, useEsnaf } from './esnaf/esnafData';

export default function Esnaf() {
  const items = useEsnaf();
  const groups = groupByIlce(items);

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Mahallebi Esnafı | Mahallendeki İşletmeler"
        description="Mahallebi'de işletme hesabı açan mahalle esnafı. Sen de işletmeni ücretsiz ekle, komşuların seni Mahallebi'de bulsun."
        path="/esnaf"
      />
      <Navigation />

      <main className="pt-28 pb-20 bg-[#f8f7f6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-3">Mahallebi Esnafı</h1>
            <p className="text-lg text-gray-600 max-w-2xl">
              Mahallebi'de işletme hesabı açan {items.length > 0 ? `${items.length} ` : ''}komşu esnafımız.
            </p>
          </div>

          {/* grid-cols-1 + min-w-0: mobilde uzun (truncate) isimler sutunu ekrandan tasirmasin */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            <div className="lg:col-span-2 space-y-10 min-w-0">
              {groups.map((group) => (
                <section key={group.ilce}>
                  <h2 className="text-xl font-bold text-[#111827] mb-4">
                    {group.ilce}
                    <span className="ml-2 text-sm font-medium text-gray-500">{group.items.length} işletme</span>
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
                    {group.items.map((item) => (
                      <EsnafCard key={item.slug} item={item} />
                    ))}
                  </div>
                </section>
              ))}
              {groups.length === 0 && (
                <p className="text-gray-600">İlk işletme sen ol — hemen ücretsiz ekle.</p>
              )}
            </div>
            <div className="lg:sticky lg:top-28">
              <EsnafJoin />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
